module.exports = __webpack_public_path__ + "e3b9511b9d7b6c0492cb39498defa8c3.svg";